const constants = {
  signature: '©' + new Date().getFullYear() + ' Begoma |  Terms of use  |  Privacy & cookies',
};

export default constants;
